<script lang="ts" setup>
definePageMeta({
  layout: 'default',
})

const districtSlug = useRoute().params.district as string

const { data } = await useAsyncData(`district-page-${districtSlug}`, () => {
  return $fetch(`/api/district/${districtSlug}`)
}, {
  getCachedData (key, nuxtApp) {
    return nuxtApp.payload.data[key]
  }
})

if (data.value.redirectToCityPage) {
  navigateTo(`/stadt/${districtSlug}`, { redirectCode: 301 })
}

const title = computed(() => {
  const base = `${data.value?.district.name}: Kfz online abmelden`

  const appendOptions = [
    ' - Außerbetriebsetzung in 3 Min',
    ' in 3 Minuten',
    ' in 3 Min',
  ]

  for (const option of appendOptions) {
    const candiate = `${base}${option}`

    if (candiate.length < 60) return candiate
  }

  return base
})

const description = `Kfz-Abmeldung für den Landkreis ${data.value?.district.name}: Abmeldebescheinigung sofort verfügbar. Außerbetriebsetzung von Fahrzeugen mit dem Smartphone oder am Computer.`

useSeoMeta({
  title,
  description
})
</script>

<template lang="pug">
#district-page.bg-white
  LandingPage(:locality="data?.district.name" :stine="data?.stine")

  section.py-24.px-3.bg-slate-700
    .container.mx-auto
      OfficesInformation(
        :offices="data?.offices"
        :locationName="data?.district.name"
        :cities="data?.cities"
      )

LayoutFooter

</template>

<style lang="sass">
</style>
